import { useCallback, useRef, useState } from 'react';
type PropsT<T extends HTMLVideoElement | HTMLAudioElement> = {
  onRefChange?: (element: T | null) => void;
};
export function useMediaElementRef<T extends HTMLVideoElement | HTMLAudioElement>({
  onRefChange
}: PropsT<T>) {
  const mediaElementRef = useRef<T | null>(null);
  const [mediaElement, setMediaElement] = useState<T | null>(null);
  const onRefChangeRef = useRef(onRefChange);
  // eslint-disable-next-line react-hooks/refs
  onRefChangeRef.current = onRefChange;
  const onMediaElementRefChange = useCallback((element: T | null) => {
    setMediaElement(element);
    mediaElementRef.current = element;
    onRefChangeRef.current?.(element);
  }, []);
  return {
    mediaElement,
    mediaElementRef,
    onMediaElementRefChange: onMediaElementRefChange
  };
}